// extracted by mini-css-extract-plugin
module.exports = {"root":"Countdown_root__2v53z","title":"Countdown_title__1fZjo","days":"Countdown_days__1p4Cj","copy":"Countdown_copy__2EBQS"};